module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/assign.js
// module id = 260
// module chunks = 168707334958949